import EditableAddress from './editable-address';
export default EditableAddress;
